module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"btn-show":"Anschauen","btn-edit":"Bearbeiten"},"fr":{"btn-show":"Consulter","btn-edit":"Éditer"},"it":{"btn-show":"Visualizzare","btn-edit":"Modificare"}}')
  delete Component.options._Ctor
}
